<div class="flex flex-col gap-[0.25rem]">
  @if (title) {
    <label class="input-title">
      {{ title }}
      @if (props.required) {
        <span class="red-10">*</span>
      }
    </label>
  }
  <div
    data-qa="selector-auto-complete"
    class="control cursor-pointer"
    (click)="showPopUpModal = props.openOnClick">
    <span class="control-text">
      {{ (isSimpleArray ? selectedItem : selectedItem?.[field]) || placeholder }}
    </span>
    <div class="suffix">
      <app-all-icons [iconNameAndStyling]="'arrow-down.svg; icon-main-size'"/>
    </div>
  </div>

  @if (props.openOnClick) {
    @if (showPopUpModal) {
      <app-popup-modal
        [innerModal]="isInsideModal"
        (closeModal)="showPopUpModal=false">
        <div class="picker flex flex-col items-center content-center full-opacity">
          <div class="picker-dropdown flex flex-col items-center content-center full-opacity w-[unset]"
               [ngClass]="outerClass === 'control-container-without-border' ? 'auto-width' : ''" #dropdown>
            <app-input
              class="flex w-[100%]"
              [autofocus]="true"
              (inputChange)="searchInputValue$.next($event)"
            />
            <div class="flex flex-col items-center content-center picker-list">
              <div class="flex flex-col items-center content-center list-block">
                @for (item of filteredData | async; track item) {
                  <div
                    class="w-full min-h-[2rem] flex flex-row items-center justify-start"
                    [attr.data-qa]="'list-entry-selected-item'"
                    [class.no-propagation]="isDataReadyForPickerCssStructure && item.isHeader"
                    [class.bg-black-2]="selectedItem === item || (field && selectedItem[field] === item[field])"
                    (click)="setSelected(item)">
                    @if (isDataReadyForPickerCssStructure) {
                      @if (item.isHeader) {
                        <span
                          data-qa="selector-autocomplete-header"
                          class="list-subheader flex flex-row items-center justify-start">
                            {{ item.header }}
                          </span>
                      } @else {
                        <div class="flex flex-row justify-between w-full list-entry sub-list"
                             [ngClass]="selectedItem === item.id ? ['bg-black-2', 'bold500'] : []">
                          <span
                            data-qa="selector-autocomplete-subheader">
                            {{ item.subheader }}
                          </span>
                          @if (item.comment) {
                            <span class="font-normal black-7">{{ item.comment }}</span>
                          }
                        </div>
                      }
                    } @else {
                      <span
                        data-qa="selector-autocomplete-header"
                        class="px-[0.46875rem] list-entry">
                        {{ isSimpleArray ? item : item[field] | linkShort:props.maxListEntryLength }}
                      </span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </app-popup-modal>
    }
  } @else {
    <div class="picker flex flex-col items-center content-center">
      <div class="picker-dropdown flex flex-col items-center content-center"
           [ngClass]="outerClass === 'control-container-without-border' ? 'auto-width' : ''" #dropdown>
        <div class="flex flex-col items-center content-center picker-list">
          <div class="flex flex-col items-center content-center list-block">
            @for (item of filteredData | async; track item) {
              <span class="list-entry" (click)="setSelected(item)">
                {{ isSimpleArray ? item : item[field] | linkShort:props.maxListEntryLength }}
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
